<template lang="pug">
v-container
  v-row
    v-col.align-self-center
      v-subheader Смена пароля
      api-form(
        v-model="data"
        v-bind="props"
        :method="save"
        :successCallback="successCallback"
      )
</template>
<script>
export default {
  data() {
    return {
      data: {},
      props: {
        fields: [
          {
            component: 'v-text-field',
            rules: 'required',
            text: 'Введите новый пароль',
            value: 'password',
            component_attrs: {
              rounded: true,
              outlined: true,
            },
          },
        ],
      },
    };
  },
  methods: {
    save({ data, obs }) {
      const payload = {
        ...data,
        token: this.$route.query.reset,
      };
      return this.$api.auth.resetPassword(payload, obs);
    },
    successCallback() {
      this.$toasted.success('Пароль успешно изменен');
      // this.$router.push('/desktop');
    },
  },
};
</script>
